module.exports = __webpack_public_path__ + "img/locatie.a0a33c9e.png";